
import './index.css';

function Tasks({ handle, meta, domain, parentId, updateDomain }) {

  const emptyTask = () => {
    return { title: '', status: 'todo', dueDate: '', sortOrder: 0 };
  };

  const metricKeyFromLabel = (label) => {
    return label
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '_');
  };

  const emptyMetric = () => {
    return {
      metricLabel: '',
      metricKey: '',
      value: '',
      targetValue: '',
      unit: '',
      recordedOn: '',
      trend: 'flat',
      note: '',
    };
  };

  const addListItem = (key, emptyValueFactory) => {
    updateDomain((prev) => ({
      ...prev,
      [key]: [...(prev[key] || []), emptyValueFactory()],
    }));
  };

  const updateListItem = (key, index, field, value) => {
    updateDomain((prev) => {
      const nextItems = [...(prev[key] || [])];
      nextItems[index] = {
        ...(nextItems[index] || {}),
        [field]: value,
      };
      return { ...prev, [key]: nextItems };
    });
  };

  const removeListItem = (key, index) => {
    updateDomain((prev) => {
      const nextItems = [...(prev[key] || [])];
      nextItems.splice(index, 1);
      return { ...prev, [key]: nextItems };
    });
  };

  return (
    <section className="card-subsection">
      <div className="row-between">
        <h3 className="section-title">Tasks</h3>
        <button className="button-secondary" type="button" onClick={() => addListItem('tasks', emptyTask)}>
          Add Task
        </button>
      </div>
      <div className="stack-sm">
        {domain.tasks?.map((item, index) => (
          <div className="inline-form-card wrap" key={item.id || `task-${index}`}>
            <input
              placeholder="Task title"
              value={item.title}
              onChange={(e) => updateListItem('tasks', index, 'title', e.target.value)}
            />
            <select value={item.status} onChange={(e) => updateListItem('tasks', index, 'status', e.target.value)}>
              <option value="todo">To Do</option>
              <option value="in_progress">In Progress</option>
              <option value="blocked">Blocked</option>
              <option value="done">Done</option>
            </select>
            <input
              type="date"
              value={item.dueDate}
              onChange={(e) => updateListItem('tasks', index, 'dueDate', e.target.value)}
            />
            <input
              type="number"
              value={item.sortOrder}
              onChange={(e) => updateListItem('tasks', index, 'sortOrder', e.target.value)}
            />
            <button className="button-danger" type="button" onClick={() => removeListItem('tasks', index, emptyTask)}>
              Remove
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Tasks;